import { ACCENT } from "./constants";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import HotelIcon from "@mui/icons-material/Hotel";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LunchDiningIcon from "@mui/icons-material/LunchDining";
import BakeryDiningIcon from "@mui/icons-material/BakeryDining";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import GridViewIcon from "@mui/icons-material/GridView";
export const formatPrice = (p) => (p === 0 ? "Free" : `₹${Number(p).toFixed(2)}`);

// The resolution a template falls back to when nothing else identifies it --
// the smallest e-paper tag, matching AllTemplates.
const DEFAULT_RESOLUTION = "296x128";

/**
 * InkHub stores a template's canvasSizeId, not a resolution string -- that is
 * the shape both the publish migrations and inkHub.manager write. Reading a
 * `resolution` key that is never there meant every template fell back to
 * 1920x1080 and got drawn at roughly a sixth of its size inside the card, so
 * resolve it from the tenant's canvas sizes the way AllTemplates does.
 *
 * @param {object} customProperties the InkHub item's customProperties
 * @param {Record<string, string>} canvasSizesById canvasSizeId -> "WxH"
 */
export const resolveInkHubResolution = (customProperties, canvasSizesById = {}) => {
  const cp = customProperties || {};
  let resolution =
    cp.resolution || canvasSizesById[cp.canvasSizeId] || DEFAULT_RESOLUTION;

  if (cp.mode === "portrait") {
    const [w, h] = String(resolution).split("x").map(Number);
    if (w && h) resolution = `${h}x${w}`;
  }

  return resolution;
};

export const mapInkHubItem = (raw, canvasSizesById = {}) => ({
  id:          raw.id,
  name:        raw.title,
  type:        raw.type,
  category:    raw.category || "",
  price:       Number(raw.price) || 0,
  rating:      raw.rating ?? 0,
  reviews:     raw.reviews ?? 0,
  description: raw.description || "",
  tags:        raw.customProperties?.tags || [],
  badge:       raw.customProperties?.badge || null,
  preview:     raw.customProperties?.preview || null,
  imageUrl:    raw.customProperties?.imageUrl || null,
  elements:    raw.customProperties?.elements || null,
  resolution:  resolveInkHubResolution(raw.customProperties, canvasSizesById),
});

export const applyFilters = (list, search, sortBy) => {
  const q = search.trim().toLowerCase();
  if (q)
    list = list.filter(
      (i) =>
        i.name.toLowerCase().includes(q) ||
        i.description.toLowerCase().includes(q) ||
        i.category.toLowerCase().includes(q) ||
        i.tags.some((t) => t.toLowerCase().includes(q))
    );
  if (sortBy === "Newest")           return [...list].reverse();
  if (sortBy === "Price: Low–High")  return [...list].sort((a, b) => a.price - b.price);
  if (sortBy === "Price: High–Low")  return [...list].sort((a, b) => b.price - a.price);
  if (sortBy === "Top Rated")        return [...list].sort((a, b) => b.rating - a.rating);
  return list;
};


export const CATEGORY_AVATAR = [
  { keys: ["meeting"],                              icon: MeetingRoomIcon,  bg: "#e3f2fd", color: "#1565c0" },
  { keys: ["hotel", "hospitality"],                 icon: HotelIcon,        bg: "#f3e5f5", color: "#6a1b9a" },
  { keys: ["bakery"],                               icon: BakeryDiningIcon, bg: "#fff8e1", color: "#f57f17" },
  { keys: ["lunch", "catering"],                    icon: LunchDiningIcon,  bg: "#fbe9e7", color: "#bf360c" },
  { keys: ["food", "restaurant", "dining", "cafe"], icon: RestaurantIcon,   bg: "#fff3e0", color: "#e65100" },
  { keys: ["shop", "retail", "store", "market"],    icon: StorefrontIcon,   bg: "#e8f5e9", color: "#2e7d32" },
  { keys: ["price", "tag", "shelf", "label", "paper", "e-paper", "epaper"], icon: LocalOfferIcon, bg: "#e0f7fa", color: "#00695c" },
];

export const getCategoryAvatar = (category) => {
  const lc = (category || "").toLowerCase();
  for (const { keys, icon, bg, color } of CATEGORY_AVATAR) {
    if (keys.some((k) => lc.includes(k))) return { icon, bg, color };
  }
  return { icon: GridViewIcon, bg: "#fdf2f4", color: ACCENT };
};